import SettingsPanel from 'components/settings-panel/SettingsPanel';
import useToggleStyle from 'hooks/common/useToggleStyle';
import { useAppContext } from 'providers/AppProvider';
import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { LoadingProvider } from "./providers/LoadingProvider";

const GA_MEASUREMENT_ID = 'G-0DM9QXTFJ7';

const App = () => {
  const { isStylesheetLoaded } = useToggleStyle();
  const { pathname, search } = useLocation();

  const {
    settingsPanelConfig: { showSettingPanelButton },
    setSettingsPanelConfig
  } = useSettingsPanelContext();

  const {
    config: { theme, isRTL }
  } = useAppContext();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // GA4: repeated gtag('config') does not reliably emit page_view; send the event explicitly.
  useEffect(() => {
    const pagePath = `${pathname}${search}`;
    window.gtag?.('event', 'page_view', {
      page_path: pagePath,
      page_location: `${window.location.origin}${pagePath}`,
      page_title: document.title
    });
  }, [pathname, search]);

  useEffect(() => {
    setSettingsPanelConfig({
      openSettingPanel: false
    });
  }, [isRTL]);

  return (
    <>
      <LoadingProvider>
        {!isStylesheetLoaded ? (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundColor: theme === 'dark' ? '#000' : '#fff'
            }}
          />
        ) : (
          <>
            <Outlet />
            {showSettingPanelButton && (
              <>
                <SettingsPanel />
              </>
            )}
          </>
        )}
      </LoadingProvider>
    </>
  );
};

export default App;
